import {PayMethod, PayMethodType} from '@web/core/constants'

export const PaymoneyDisableCase = {
    /** 은행 전체 점검 */
    ALL_BANK_UNDER_MAINTENANCE: 'ALL_BANK_UNDER_MAINTENANCE',
    /** 페이머니 통장 연결은행 점검 케이스 */
    PAYMONEY_ACCOUNT_UNDER_MAINTENANCE: 'PAYMONEY_ACCOUNT_UNDER_MAINTENANCE',
    /** 페이머니 정보 조회 실패 (페이시스템 점검으로 인해 재조회 불가) */
    PAYMONEY_UNDER_MAINTENANCE: 'PAYMONEY_UNDER_MAINTENANCE',
    /** 비현금성 머니 보유 + 포인트 사용 불가 가맹점 (머니 only 가맹점) */
    NON_CASH_EVIDENCE_INCLUDED_MONEY: 'NON_CASH_EVIDENCE_INCLUDED_MONEY',
    /** 머니 통장 연결 오류 (2.0 유저 케이스) */
    PAYMONEY_TRANSFER_FAIL: 'PAYMONEY_TRANSFER_FAIL',
    /** 페이머니 정보 조회 실패  (재조회 시도 가능) */
    PAYMONEY_INFO_LOAD_FAILURE: 'PAYMONEY_INFO_LOAD_FAILURE',
    /** 페이머니 사용금 200 초과시 */
    AMOUNT_OVER_MAXIMUM_LIMIT: 'AMOUNT_OVER_MAXIMUM_LIMIT',
    /** 페이머니 통장 거래중지 케이스 (4.1 유저) */
    PAYMONEY_ACCOUNT_SUSPENDED: 'PAYMONEY_ACCOUNT_SUSPENDED',
    /** 머니 충전가능 금액 부족 케이스 (1.0 유저) */
    NOT_ENOUGH_CHARGE_LIMIT: 'NOT_ENOUGH_CHARGE_LIMIT',
} as const

export const CashReceiptAvailableMethods: PayMethodType[] = [
    PayMethod.BANK_EASY_PAY,
    PayMethod.CARD_EASY_PAY,
    PayMethod.RECHARGE_POINT,
]
